import { isDefined, isOlderThan, isYoungerThan } from "Utils/functions";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { ProductBackendName } from "./productTypes";

export const productBackendNameToInsuranceName = (
  productBackendName: ProductBackendName,
): INSURANCE_NAME_VALUE | undefined => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (productBackendName) {
    case ProductBackendName.ACCIDENT:
      return INSURANCE_NAME_VALUE.ACCIDENT;
    case ProductBackendName.ADVICE:
      return INSURANCE_NAME_VALUE.ADVICE;
    case ProductBackendName.AKA_CHILD:
      return INSURANCE_NAME_VALUE.AKA_CHILD;
    case ProductBackendName.AKA_CRITICAL_ILLNESS:
      return INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS;
    case ProductBackendName.AKA_FAMILY_ACCIDENT:
      return INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT;
    case ProductBackendName.AKA_GROUP_LIFE:
      return INSURANCE_NAME_VALUE.AKA_GROUP_LIFE;
    case ProductBackendName.AKA_HOUSE_CONTENTS:
      return INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS;
    case ProductBackendName.AKA_STUDENT:
      return INSURANCE_NAME_VALUE.AKA_STUDENT;
    case ProductBackendName.AKA_TRAVEL:
      return INSURANCE_NAME_VALUE.AKA_TRAVEL;
    case ProductBackendName.AKA_HEALTH:
      return INSURANCE_NAME_VALUE.AKA_HEALTH;
    case ProductBackendName.ANIMAL:
      return INSURANCE_NAME_VALUE.ANIMAL;
    case ProductBackendName.BOAT:
      return INSURANCE_NAME_VALUE.BOAT;
    case ProductBackendName.CABIN:
      return INSURANCE_NAME_VALUE.CABIN;
    case ProductBackendName.CABIN_CONTENTS:
      return INSURANCE_NAME_VALUE.CABIN_CONTENTS;
    case ProductBackendName.CAR:
      return INSURANCE_NAME_VALUE.CAR;
    case ProductBackendName.CARAVAN:
      return INSURANCE_NAME_VALUE.CARAVAN;
    case ProductBackendName.CHILD:
      return INSURANCE_NAME_VALUE.NEW_CHILD;
    case ProductBackendName.CHILD_HEALTH:
      return INSURANCE_NAME_VALUE.CHILD_HEALTH;
    case ProductBackendName.CRITICAL_ILLNESS:
      return INSURANCE_NAME_VALUE.CRITICAL_ILLNESS;
    case ProductBackendName.DEATH:
      return INSURANCE_NAME_VALUE.DEATH;
    case ProductBackendName.DISABILITY:
      return INSURANCE_NAME_VALUE.DISABILITY_FLEX;
    case ProductBackendName.ELECTRIC_SCOOTER:
      return INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER;
    case ProductBackendName.HEALTH:
      return INSURANCE_NAME_VALUE.HEALTH;
    case ProductBackendName.HOUSE:
      return INSURANCE_NAME_VALUE.HOUSE;
    case ProductBackendName.HOUSE_CONTENTS:
      return INSURANCE_NAME_VALUE.HOUSE_CONTENTS;
    case ProductBackendName.HUSEIERNE_HOUSE_CONTENTS:
      return INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS;
    case ProductBackendName.MOPED:
      return INSURANCE_NAME_VALUE.MOPED;
    case ProductBackendName.MOTORCYCLE:
      return INSURANCE_NAME_VALUE.MOTORCYCLE;
    case ProductBackendName.RENTAL:
      return INSURANCE_NAME_VALUE.RENTAL;
    case ProductBackendName.PREGNANT_AND_NEWBORN:
      return INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN;
    case ProductBackendName.SOP_SICKNESS_LEAVE:
      return INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE;
    case ProductBackendName.TRACTOR:
      return INSURANCE_NAME_VALUE.TRACTOR;
    case ProductBackendName.TRAILER:
      return INSURANCE_NAME_VALUE.TRAILER;
    case ProductBackendName.TRAVEL:
      return INSURANCE_NAME_VALUE.TRAVEL;
    case ProductBackendName.VALUABLES:
      return INSURANCE_NAME_VALUE.VALUABLES;
    case ProductBackendName.VETERAN_AUTO:
      return INSURANCE_NAME_VALUE.VETERAN_AUTO;
    default:
      return undefined;
  }
};

export const insuranceNameToProductBackendName = (
  insuranceName: INSURANCE_NAME_VALUE,
): ProductBackendName | undefined => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (insuranceName) {
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return ProductBackendName.ACCIDENT;
    case INSURANCE_NAME_VALUE.AKA_CHILD:
      return ProductBackendName.AKA_CHILD;
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return ProductBackendName.AKA_STUDENT;
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return ProductBackendName.AKA_TRAVEL;
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
      return ProductBackendName.AKA_FAMILY_ACCIDENT;
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
    case INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING:
      return ProductBackendName.AKA_HEALTH;
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return ProductBackendName.AKA_HOUSE_CONTENTS;
    case INSURANCE_NAME_VALUE.ANIMAL:
      return ProductBackendName.ANIMAL;
    case INSURANCE_NAME_VALUE.BOAT:
      return ProductBackendName.BOAT;
    case INSURANCE_NAME_VALUE.CABIN:
      return ProductBackendName.CABIN;
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return ProductBackendName.CABIN_CONTENTS;
    case INSURANCE_NAME_VALUE.CAR:
      return ProductBackendName.CAR;
    case INSURANCE_NAME_VALUE.CARAVAN:
      return ProductBackendName.CARAVAN;
    case INSURANCE_NAME_VALUE.NEW_CHILD:
      return ProductBackendName.CHILD;
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return ProductBackendName.CHILD_HEALTH;
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
      return ProductBackendName.CRITICAL_ILLNESS;
    case INSURANCE_NAME_VALUE.DEATH:
      return ProductBackendName.DEATH;
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return ProductBackendName.DISABILITY;
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return ProductBackendName.ELECTRIC_SCOOTER;
    case INSURANCE_NAME_VALUE.HEALTH:
    case INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING:
      return ProductBackendName.HEALTH;
    case INSURANCE_NAME_VALUE.HOUSE:
      return ProductBackendName.HOUSE;
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return ProductBackendName.HOUSE_CONTENTS;
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return ProductBackendName.HUSEIERNE_HOUSE_CONTENTS;
    case INSURANCE_NAME_VALUE.MOPED:
      return ProductBackendName.MOPED;
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return ProductBackendName.MOTORCYCLE;
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
      return ProductBackendName.PREGNANT_AND_NEWBORN;
    case INSURANCE_NAME_VALUE.RENTAL:
      return ProductBackendName.RENTAL;
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return ProductBackendName.SOP_SICKNESS_LEAVE;
    case INSURANCE_NAME_VALUE.TRACTOR:
      return ProductBackendName.TRACTOR;
    case INSURANCE_NAME_VALUE.TRAILER:
      return ProductBackendName.TRAILER;
    case INSURANCE_NAME_VALUE.TRAVEL:
      return ProductBackendName.TRAVEL;
    case INSURANCE_NAME_VALUE.VALUABLES:
      return ProductBackendName.VALUABLES;
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return ProductBackendName.VETERAN_AUTO;
    default:
      return undefined;
  }
};

export const isFormInitialState = (
  initialFormState: Partial<FormState>,
): boolean => Object.keys(initialFormState).length > 0;

export const isCustomerTooOld = (
  maxAge: number,
  customerDateOfBirth?: string,
): boolean => {
  if (isDefined(customerDateOfBirth)) {
    return isOlderThan(maxAge, new Date(customerDateOfBirth));
  }
  return false;
};

export const isCustomerTooYoung = (
  minAge: number,
  customerDateOfBirth?: string,
): boolean => {
  if (isDefined(customerDateOfBirth)) {
    return isYoungerThan(minAge, new Date(customerDateOfBirth));
  }
  return false;
};
